import gql from 'graphql-tag';

export const CreateTemplate = gql`
  mutation CreateTemplate($organizationId: ID!, $request: CreateTemplateRequest!) {
    createTemplate(organizationId: $organizationId, request: $request) {
      id
    }
  }
`;
